import { useEffect, useState } from "react"
import Modal from 'react-modal';
import { useParams } from "react-router";
import useKeypress from "../ownHooks/pressEsc";

var MonitorApi = require('monitor-api');

export default function EinwohnerUpdate ({ rowEntry, instance, reloadData}) {
    const {uniqueYear} = useParams();
    const [showModal, setShowModal] = useState(false);
    const [einwohner, setEinwohner] = useState(rowEntry.einwohner);
    const [updateEinwohner, setUpdateEinwohner] = useState(new MonitorApi.EinwohnerUpdate());

    useKeypress('Escape', () => {
        cancel();
    });

    useEffect(() => {
        if (showModal) 
            {
                setEinwohner(rowEntry.einwohner);
            }
    }, [showModal, rowEntry.einwohner])
    const changeEinwohner = event => {
        event.preventDefault();
        if (event.target.value >= 0) {
            setEinwohner(event.target.value);
            updateEinwohner.einwohner = event.target.value;
            setUpdateEinwohner(updateEinwohner);
        } else {
            setEinwohner("");
        }
    }

    const cancel = () => {
        setEinwohner(rowEntry.einwohner);
        setShowModal(false);
    }

    const saveChanges = event => {
        event.preventDefault();
        instance.updateEinwohnerOfYearOfZweckverband(uniqueYear, rowEntry.id_zv, updateEinwohner, (error, data) => {
            if (error) {
                console.log(error);
                alert('Irgendwas ging schief...');
            } else {
                setShowModal(false);
                reloadData(uniqueYear);
            }
        })
    }

    const newChanges = () => {
        if (parseInt(einwohner) === rowEntry.einwohner || einwohner === "") {
            return false;
        }
        return true;
    }

    return (
        <div>
            <button className="update-bttn" onClick={() => setShowModal(true)}>Bearbeiten</button>
            <Modal isOpen={showModal} className="modal" >
                <div>
                    <button className="bttn-close-modal" onClick={cancel}>&#10007; </button>
                    <br></br>
                    <div>
                        <h4>Änderungen eintragen für {rowEntry.jahr}:</h4>
                        <label>Zweckverband: {rowEntry.verband}
                            <input type="number" min="0" value={einwohner} onChange={changeEinwohner}/>
                        </label>
                        {/* <br></br> */}
                    </div>
                    <button disabled={!newChanges()} onClick={saveChanges}>Speichern</button>
                    <button onClick={cancel}>Abbruch</button>
                </div>
            </Modal>
        </div>
    )
}